<template>
  <b-card class="p-1 content-card" :style="'border: 11px solid transparent;'+`border-image: url('${borderImage}') 30 round`">
    <b-col cols="12" class="d-flex flex-column align-items-center">
      <slot name="p-1"></slot>
    </b-col>
  </b-card>
</template>

<script>
export default {
  name: "C101",
  props:['borderImage']
}
</script>

<style scoped>
.tab-row .card {
  height: 250px !important;
}
</style>